import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GlobalApplicationToolbarComponent } from './core/components/global-application-toolbar/global-application-toolbar.component';
import { SidebarNewComponent } from './core/components/sidebar-new/sidebar-new.component';
import { ToastComponent } from './core/components/toast/toast.component';
import { CommonModule } from '@angular/common';
import { UserAuthService } from './core/services/user-auth.service';
import { EnvironmentService } from './services/environment.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeepLinkService } from './services/deep-link.service';

@Component({
	selector: 'adf-root',
	imports: [TranslateModule, GlobalApplicationToolbarComponent, SidebarNewComponent, RouterModule, ToastComponent, CommonModule],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	standalone: true,
})
export class AppComponent implements OnInit {
	readonly _destroyRef = inject(DestroyRef);
	private _translate: TranslateService = inject(TranslateService);
	private _userAuthService = inject(UserAuthService);
	private _environmentService = inject(EnvironmentService);
	private readonly _deepLinkService = inject(DeepLinkService);

	isElectronApp = this._environmentService.isElectron();
	userIsAuthenticated = false;
	isOnline = navigator.onLine;

	constructor() {
		this._translate.addLangs(['en']);
		this._translate.setDefaultLang('en');
		this._translate.use('en');

		const initialUrl = globalThis.location.pathname + globalThis.location.search;
		if (initialUrl && initialUrl !== '/' && initialUrl !== '/home') {
			this._deepLinkService.storePendingUrl(initialUrl);
		}

		this._userAuthService.getCurrentUser()
			.pipe(takeUntilDestroyed(this._destroyRef))
			.subscribe((user) => {
				this.userIsAuthenticated = !!user;
			});
	}

	ngOnInit(): void {
		this._userAuthService.initAuth();
	}
}
